var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contend"},[_c('MENU'),_c('MAIN')],1)}
var staticRenderFns = []

export { render, staticRenderFns }